// extracted by mini-css-extract-plugin
module.exports = {"root":"Navbar_root__2_LJX","span":"Navbar_span__2gOAK","button":"Navbar_button__1LR--","logo":"Navbar_logo__2rEoR","menu":"Navbar_menu__22Kdq","a":"Navbar_a__2hMrX"};